import { render, staticRenderFns } from "./navbar.vue?vue&type=template&id=b042a7d8&scoped=true"
import script from "./navbar.vue?vue&type=script&lang=ts"
export * from "./navbar.vue?vue&type=script&lang=ts"
import style0 from "./navbar.vue?vue&type=style&index=0&id=b042a7d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b042a7d8",
  null
  
)

export default component.exports